import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardTabs from '../components/shared/DashboardTabs';
import FilterBar from '../components/FilterBar';
import SessionsTable from '../components/SessionsTable';
import useDashboardViewModel from '../hooks/useDashboardViewModel';

export default function DashboardPage (): React.JSX.Element {
  const navigate = useNavigate();
  const {
    sessions,
    totalSessions,
    totalPages,
    currentPage,
    rowsPerPage,
    setCurrentPage,
    setRowsPerPage,
    sessionsLoadingState,
    isSuperAdmin,
    organizations,
    downloadReport,
    downloadingSessionId,
  } = useDashboardViewModel();

  const handleSessionClick = (sessionId: string): void => {
    navigate(`/dashboard/session/${sessionId}`);
  };

  const isLoading = sessionsLoadingState === 'LOADING' || sessionsLoadingState === 'IDLE';

  return (
    <div className="space-y-4">
      {/* Header: Tabs */}
      
      <DashboardTabs />
      
      {/* Filter Bar */}
      <FilterBar isSuperAdmin={isSuperAdmin} organizations={organizations} />

      {/* Sessions Table */}
      <SessionsTable
        sessions={sessions}
        loading={isLoading}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalSessions}
        rowsPerPage={rowsPerPage}
        onPageChange={setCurrentPage}
        onRowsPerPageChange={setRowsPerPage}
        onSessionClick={handleSessionClick}
        onDownloadReport={downloadReport}
        downloadingSessionId={downloadingSessionId}
      />
    </div>
  );
}
